import React from "react";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loader from "../../../assets/components/Loader";

type Props = {
    component: React.ComponentType | typeof React.Component
}

const PrivateRoute = ({component}: Props): JSX.Element => {
    const Component = withAuthenticationRequired(component, {
        onRedirecting: () => <Loader/>
    });
    return <Component/>;
};

export default PrivateRoute;